export const itemOptions = [
  "Bed",
  "Bed Handle",
  "Bedroom OH",
  "Ensuite",
  "Ensuite OH",
  "Entry",
  "Entry Cupboard",
  "Fire Extinguisher",
  "Fridge Flap",
  "Kitchen",
  "Kitchen Cupboard",
  "Kitchen Entry",
  "Kitchen Benchtop",
  "Kitchen Overhead",
  "Kitchen Partition",
  "Lounge Cupboard",
  "Lounge Door Side",
  "Lounge LH",
  "Lounge OH",
  "Lounge Rear",
  "Lounge RH",
  "Microwave Cupboard",
  "Microwave Fascia",
  "Mirror",
  "Outside Van",
  "Pantry",
  "Pot Drawer",
  "Power Inlet",
  "Roof",
  "Shower",
  "Shower Base",
  "Shower Partition",
  "Sliding Door",
  "Table Top",
  "Toilet",
  "Trifold Cupboard",
  "Trifold Table",
  "Tunnel Boot",
  "Vanity",
  "Vanity Basin",
  "Vanity Cupboard",
  "Wardrobe LH",
  "Wardrobe RH",
  "Washing Cupboard",
  "Washing Machine",
];
export const stationOptions = [
  "OP0 - Chassis",
  "OP1 - Floor",
  "OP2/3 - Building",
  "OP4/5/10 - Electrical",
  "OP6 - Wall Assembly",
  "OP7 - Roof Assembly",
  "OP8 - J-Mould",
  "OP9/13/18 - QC",
  "OP11/12 - Finishing",
  "OP14 - Doors & Drawers",
  "OP15 - Green Tag",
  "OP16 - Cleaning",
  "OP17 - Sealing",
  "CNC",
  "Edging",
  "Furniture",
  "Damaged",
  "Plumbing",
  "Detailing",
  "Decal",
  "Planning",
];
